<div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="row">{{ "user.title" | translate }}</h2>
    <div *ngIf="topMenuIcons.length > 0">
      <button
          mat-raised-button
          [disabled]="
          !this.detailForm.valid ||
          !this.selectedProfiles ||
          this.selectedProfiles.length == 0 ||
          this.disableByProfile"
          (click)="save()"
        >
        <mat-icon [title]="this.saveIconTitle"> save </mat-icon>
        </button>
        <button
          mat-raised-button
          *ngIf="this.id !== 'new'"
          (click)="deleteConfirm()"
          [disabled]="this.disableByProfile"
        >
        <mat-icon [title]="this.deleteIconTitle"> delete </mat-icon>
        </button>
        <ng-container *ngFor="let action of topMenuIcons">
          <button
            mat-raised-button
            *ngIf="!action.hide"
            [routerLink]="action.routerLink"
            (click)="this[action.clickMethod]()"
          >
            <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
          </button>
        </ng-container>
    </div>
  </div>
  <form [formGroup]="detailForm">
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="40px">
        <mat-form-field
          *ngIf="columnsVisible.get('id')"
          [ngStyle]="{
            'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
            'min-width.px': 300
          }"
        >
          <mat-label> {{ "user.id" | translate }} </mat-label>
          <input
            matInput
            [ngStyle]="{
              'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
              'min-width.px': 300
            }"
            formControlName="id"
          />
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('displayName')"
          [ngStyle]="{
            'width.ch': detailForm.controls['displayName'].value ? detailForm.controls['displayName'].value.length : 10,
            'min-width.px': 300
          }"
        >
          <mat-label>{{ "user.name" | translate }}</mat-label>
          <input
            matInput
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['displayName'].value ? detailForm.controls['displayName'].value.length : 10,
              'min-width.px': 300
            }"
            formControlName="displayName"
          />
          <mat-error *ngIf="detailForm.controls['displayName'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('email')"
          [ngStyle]="{
            'width.ch': detailForm.controls['email'].value ? detailForm.controls['email'].value.length : 10,
            'min-width.px': 300
          }"
        >
          <mat-label>{{ "user.email" | translate }}</mat-label>
          <input
            matInput
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['email'].value ? detailForm.controls['email'].value.length : 10,
              'min-width.px': 300
            }"
            formControlName="email"
          />
          <mat-error *ngIf="detailForm.controls['email'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['email'].errors?.['email']">
            {{ "error.email" | translate }}
          </mat-error>
        </mat-form-field>

      </div>

      <div fxLayout="column">
        <div fxLayout="row wrap" fxLayoutGap="40px">

          <app-profile-dropdown *ngIf="columnsVisible.get('profile')"
          (selectedChange)="this.setSelectedProfile($event)"
          [required]="true"
          [singleSelection]="true"
          [selected]="this.preSelectedProfile"
        ></app-profile-dropdown>

        <mat-form-field *ngIf="this.id !== 'new' && columnsVisible.get('profile_disabled')" [ngStyle]="{
          'width.ch': detailForm.controls['profile_disabled'].value ? detailForm.controls['profile_disabled'].value.length : 10,
          'min-width.px': 300
       }">
           <mat-label>{{ "user.profile" | translate }}</mat-label>
           <input matInput [disabled]="true" [ngStyle]="{
           'width.ch': detailForm.controls['profile_disabled'].value ? detailForm.controls['profile_disabled'].value.length : 10,
           'min-width.px': 300
       }" />{{ this.preSelectedProfile }}
         </mat-form-field>

          <mat-checkbox *ngIf="columnsVisible.get('enabled')" matInput
                [ngStyle]="{
                  'width.ch': 10,
                    'min-width.px': 80

                }" formControlName="enabled">{{ "user.enabled" | translate }}</mat-checkbox>
        </div>
      </div>

      <div style="margin-top: 15px;" [hidden]="this.id === 'new' || !originalEnabled || this.disableByProfile">
        <button mat-raised-button (click)="showChangePassword = !showChangePassword" [disabled]="this.id === 'new'">
            {{ "change-password.button" | translate }}
        </button>
    </div>
      <div fxLayout="row wrap" fxLayoutGap="40px" style="margin-top: 15px;" [hidden]="!showChangePassword">
         <app-change-password *ngIf="showChangePassword" [userId]="this.detailForm.controls['id'].value" [userNameLogin]="this.detailForm.controls['email'].value" [changeUserPassword]="true"></app-change-password>
      </div>
    </div>

    <mat-accordion multi>
      <mat-expansion-panel *ngIf="this.id !== 'new'" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'log-messages.title' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
          <mat-panel-description>
        <app-log-messages-list [ngStyle]="{
          'width.pc': 100
        }" [modelId]="this.id"></app-log-messages-list>
        </mat-panel-description>
      </mat-expansion-panel>
    </mat-accordion>
  </form>

